import { FC } from 'react';

import Ava from '../../../../components/Common/Ava/Ava';
import { getNameOrId } from '../../../../utils/helper';
import './HolderAccount.scss';
import { Distribution_Holder_Partner } from '../../../../generated/mlmbox/types/distribution';

const HolderAccount: FC<{ holder: Distribution_Holder_Partner; index: number; onClick?: () => void }> = ({ holder, index, onClick }) => {
    return (
        <div
            className="holder-account"
            onClick={onClick}>
            <div className="holder-account__info">
                <Ava
                    collectionId={holder.account?.profile?.ava?.collectionId}
                    entityId={holder.account?.profile?.ava?.entityId}
                    width="40px"
                    height="40px"
                    borderColor="none"
                />

                <div className="holder-account__info--data">
                    <h2>{holder.account && getNameOrId(holder.account)}</h2>
                    {/* <p>{(Number(holder.state?.balance?.web3 ?? 0) + Number(holder.state?.balance?.wallet ?? 0)).toLocaleString()} $MOON</p> */}
                    <p>{Number(Number(holder.turnoverForSponsor ?? 0).toFixed(0)).toLocaleString()} $MOON</p>
                </div>
            </div>
            <div className={`holder-account__number ${index === 0 || index === 1 || index === 2 ? 'top' : ''}`}>
                <div
                    className={`bg ${index === 0 || index === 1 || index === 2 ? 'tops' : ''} ${
                        index === 0 ? 'first' : index === 1 ? 'second' : index === 2 ? 'third' : ''
                    }`}></div>
                <div
                    className={`bg2 ${index === 0 || index === 1 || index === 2 ? 'tops' : ''} ${
                        index === 0 ? 'first' : index === 1 ? 'second' : index === 2 ? 'third' : ''
                    }`}></div>

                <div className="tr">
                    {(index === 0 || index === 1 || index === 2) && <h3>{index + 1}</h3>}
                    <h2>{index === 0 ? 'st' : index === 1 ? 'nd' : index === 2 ? 'rd' : index + 1}</h2>
                </div>
            </div>
        </div>
    );
};

export default HolderAccount;
